var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin-with-circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linkedin-with-circle",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,-6.9388939e-16 C8.95416667,-6.9388939e-16 -6.9388939e-16,8.95416667 -6.9388939e-16,20 C-6.9388939e-16,31.0458333 8.95416667,40 20,40 C31.0458333,40 40,31.0458333 40,20 C40,8.95416667 31.0458333,-6.9388939e-16 20,-6.9388939e-16 Z M15.1041667,28.2895833 L11.0541667,28.2895833 L11.0541667,15.25625 L15.1041667,15.25625 L15.1041667,28.2895833 Z M13.0541667,13.65625 C11.775,13.65625 10.9479167,12.75 10.9479167,11.6291667 C10.9479167,10.4854167 11.8,9.60625 13.10625,9.60625 C14.4125,9.60625 15.2125,10.4854167 15.2375,11.6291667 C15.2375,12.75 14.4125,13.65625 13.0541667,13.65625 Z M29.8958333,28.2895833 L25.8458333,28.2895833 L25.8458333,21.0666667 C25.8458333,19.3854167 25.2583333,18.24375 23.79375,18.24375 C22.675,18.24375 22.0104167,19.0166667 21.7166667,19.7604167 C21.6083333,20.025 21.58125,20.4 21.58125,20.7729167 L21.58125,28.2875 L17.5291667,28.2875 L17.5291667,19.4125 C17.5291667,17.7854167 17.4770833,16.425 17.4229167,15.2541667 L20.9416667,15.2541667 L21.1270833,17.0645833 L21.2083333,17.0645833 C21.7416667,16.2145833 23.0479167,14.9604167 25.2333333,14.9604167 C27.8979167,14.9604167 29.8958333,16.7458333 29.8958333,20.5833333 L29.8958333,28.2895833 L29.8958333,28.2895833 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.f128a3ccc8feb9229470cce767d82341.svg";
export { ForwardRef as ReactComponent };